import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './faqs.css'; // We'll define custom styles here

const FAQs = () => {
  const faqs = [
    {
      question: '1) What is Fundswalle?',
      answer: 'Fundswalle is a trusted online lending platform offering quick and hassle-free personal loans exclusively to salaried individuals. Operated under Marathon Finlease Private Limited, a Non-Banking Financial Company (NBFC) registered with the Reserve Bank of India (RBI), Fundswalle is committed to providing simple, transparent, and reliable financial solutions. Whether it’s managing an emergency, upgrading your home, or celebrating life’s special moments, Fundswalle ensures that your financial needs are met with ease, speed, and confidence.',
    },
   {
  question: '2) Who is eligible to apply for a personal loan from Fundswalle?',
  answer: 'To be eligible for a personal loan with Fundswalle, you must meet the following criteria: \n•  Be a salaried individual\n• Be between 21 and 60 years of age\n• Have a minimum of 6 months of continuous employment with a recognized   organization\n• Earn a minimum monthly salary as defined by Fundswalle’s eligibility standards.'
},

 {
  question: '3)	What documents are required to apply for a personal loan?',
  answer: 'You will need to submit the following documents when applying for a personal loan with Fundswalle: \n•  Proof of identity – Aadhaar Card, PAN Card, Passport, or any valid government-issued ID\n• Proof of address – Utility bills or other acceptable address proof\n•  Salary slips for the last three months\n• Bank statements for the last six months.'
},

    {
      question: '4) How much can I borrow from Fundswalle?',
      answer: 'Fundswalle offers personal loans ranging from ₹5,000 to ₹1,00,000, based on your salary, credit score, and repayment capacity. The final approved amount is determined after assessing your eligibility and financial profile.',
    },
    {
      question: '5) What is the interest rate on personal loans at Fundswalle?',
      answer: 'The interest rate is determined by factors such as your credit profile, loan amount, and repayment tenure. Fundswalle offers competitive and affordable rates tailored specifically for salaried individuals. You may contact our team to receive a personalized quote based on your eligibility and financial profile.',
    },
    {
      question: '6) How long does it take to get the loan approved and disbursed?',
      answer: 'Once your application and documents are submitted, our team reviews them promptly. Loan approval typically takes only a few minutes, and the approved amount is disbursed directly to your bank account within 30 minutes.',
    },

    {
      question: '7) Can I repay my loan early?',
      answer: 'Yes, Fundswalle allows early repayment of personal loans without any hassle. You can refer to your loan agreement or contact our support team for details on the prepayment process and applicable terms.',
    },

      {
      question: '8) How does Fundswalle assess my creditworthiness?',
      answer: 'Fundswalle evaluates your loan eligibility based on key factors such as your monthly income, credit score, employment stability, and repayment history. Maintaining a strong credit score enhances your chances of quick approval and helps you secure a more favourable interest rate',
    },

          {
      question: '9) Can I apply for a loan if I have a low credit score?',
      answer: 'Yes, you can apply for a loan even with a low credit score. However, approval and interest rates will depend on your overall financial profile, income stability, and repayment capacity.',
    },

              {
      question: '10) How do I repay my loan to Fundswalle?',
      answer: 'You can repay your loan using multiple payment options, including NACH (National Automated Clearing House), direct debit from your bank account, or secure online payments through our website.',
    },

                  {
      question: '11) Is my personal and financial information safe with Fundswalle?',
      answer: 'Absolutely. Fundswalle employs advanced security protocols, including data encryption and secure servers, to safeguard your personal and financial information. We fully comply with data privacy regulations and handle all customer information with the highest level of confidentiality.',
    },

   {
      question: '12) Can I check the status of my loan application?',
      answer: 'Yes, you can conveniently track your loan application status by logging into your account on the Fundswalle website. You’ll also receive real-time updates via email and SMS at every stage of the process.',
    },

      {
      question: '13) How can I contact customer support for further assistance?',
      answer: 'You can reach our customer support team through the contact form on our website, by email at support@fundswalle.com or by calling our helpline during business hours. Our team is always ready to assist you with any queries or concerns.',
    },
  ];

  return (
    <section className="faq-section py-3">
      <div className="container">
        <h2 style={{ color: '#052daa', textAlign: 'center', marginBottom: '2rem' }}>Frequently Asked Questions</h2>
        <div className="accordion" id="faqAccordion">
          {faqs.map((faq, index) => (
            <div className="accordion-item border-0 mb-3 shadow-sm" key={index}>
              <h2 className="accordion-header" id={`heading${index}`}>
                <button
                  className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${index}`}
                  aria-expanded={index === 0 ? 'true' : 'false'}
                  aria-controls={`collapse${index}`}
                >
                  {faq.question}
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                aria-labelledby={`heading${index}`}
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQs;
